import HubPage from '../../components/HubPage';
export default function CRMHub() { return <HubPage hubKey="crm" />; }
